/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
'use strict';

import { FormActions, RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import { ClassNames as BaseClassNames } from '../constants/Constants';
import FliwasOrganizationWebApi from '../webapi/FliwasOrganizationWebApi';

const className = BaseClassNames.Group;

export default {
    list: (name, query) => RemoteDataActions.list(name, className, query, FliwasOrganizationWebApi.list),
    listForFederalState: (name, query) => RemoteDataActions.list(name, className, query, FliwasOrganizationWebApi.listForFederalState),
    search: (name, query) => RemoteDataActions.list(name, className, query, FliwasOrganizationWebApi.search),
    item: (name, query) => RemoteDataActions.item(name, className, query, FliwasOrganizationWebApi.get),
    itemByGroupId: (name, query) => RemoteDataActions.item(name, className, query, FliwasOrganizationWebApi.getByGroupId),
    itemsByGroupIds: (name, query) => RemoteDataActions.list(name, className, query, FliwasOrganizationWebApi.getByGroupIds),
    getUsedTerritorialEntities: () => FliwasOrganizationWebApi.getUsedTerritorialEntities(),

    moreItems: (name, query) => RemoteDataActions.moreItems(name, className, query),

    listFederalStates: (name, query) => RemoteDataActions.list(name, className, query, FliwasOrganizationWebApi.listFederalStates),
    listAll: (name, query) => RemoteDataActions.list(name, className, query, FliwasOrganizationWebApi.listAll),

    setManualState: (item, formId, closeForm) => FormActions.submitForm(FliwasOrganizationWebApi.setManualState, item, formId, closeForm),
    createItem: (item, formId, closeForm) => FormActions.submitForm(FliwasOrganizationWebApi.addFliwasOrganization, item, formId, closeForm),
    updateItem: (item, formId, closeForm) => FormActions.submitForm(FliwasOrganizationWebApi.updateFliwasOrganization, item, formId, closeForm),
    resetGroupPermissions: (groupId) => FliwasOrganizationWebApi.resetGroupPermissions(groupId)
};



// WEBPACK FOOTER //
// ./js/actions/FliwasOrganizationActions.js